import React from 'react';
import { withStyles } from '@material-ui/core/styles';

import combineStyles from '../../utils/combineStyles';
import TypographyStyles from '../../styles/typography';

const styles = theme => ({
  root: {
    width: 164,
    height: 164,
    borderRadius: 16.4
  },
  initials: {
    color: 'rgba(12,31,44,0.38)',
    fontFamily: theme.typography.font.second,
    fontSize: 65.6,
    fontWeight: 500,
    letterSpacing: '4.1px',
    margin: 0,
    height: '100%',
    width: '100%',
    backgroundColor: '#EBEEF1',
    borderRadius: 16.4,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  }
});

export const Avatar = ({ classes, user }) => {
  return (
    <div className={classes.root}>
      <p className={classes.initials}>
        {user.firstName[0]}
        {user.lastName[0]}
      </p>
    </div>
  );
};

export default withStyles(combineStyles(styles, TypographyStyles))(Avatar);
